import store from './index';
export const selectPlaces = () => store((state) => state.places);
export const selectPlacesByDistrict = () => store((state) => state.placesByDistrict);
export const selectPlacesByProject = () => store((state) => state.placesByProject);
export const selectSelectedPlace = () => store((state) => state.selected);
export const selectPlacesCategories = () => store((state) => state.categories);
export const selectPlacesDashboard = () => store((state) => state.dashboard);
export const selectPlacesFilters = () => store((state) => state.filters);
export default {
    setSelected: store.getState().setSelected,
    getPlaces: store.getState().getPlaces,
    getPlacesByDistrict: store.getState().getPlacesByDistrict,
    getPlacesByProject: store.getState().getPlacesByProject,
    getPlacesCategories: store.getState().getPlacesCategories,
    clearPlacesCategories: store.getState().clearPlacesCategories,
    getPlacesCategory: store.getState().getPlacesCategory,
    getPlace: store.getState().getPlace,
    getPlacesDashboard: store.getState().getPlacesDashboard,
    getPlaceDashboard: store.getState().getPlaceDashboard,
    deletePlacesCategory: store.getState().deletePlacesCategory,
    deletePlaces: store.getState().deletePlaces,
    setPlacesFilters: store.getState().setPlacesFilters,
    createPlacesCategory: store.getState().createPlacesCategory,
    editPlacesCategory: store.getState().editPlacesCategory,
    createPlace: store.getState().createPlace,
    editPlace: store.getState().editPlace,
};
